import * as React from 'react';
import { Paper, Typography, TextField, Button, Avatar, makeStyles } from '@material-ui/core';
import {
  DailyReportComment,
  DailyReportCommentModel,
} from '../../../models/DailyReport/DailyReportCommentModel';
import DailyReportCommentItem from './DairyReportCommentItem';
import { useState } from 'react';
import { DailyReport } from '../../../models/DailyReport/DailyReportModel';
import NotificationToast from '../NotificationToast';
import { DailyReportCommentOpenContext } from '../../../screens/dailyReport/DailyReportScreen';
import CommentInput from './CommentInput';
import { Stamp } from '../../../models/DailyReport/StampModel';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(1),
    // marginBottom: theme.spacing(1),
    backgroundColor: '#FFFFFF',
  },
  commentSection: {
    // marginTop: theme.spacing(1),
  },
  comment: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
  },
  commentBlue: {
    backgroundColor: '#bbdefb',
  },
  commentPink: {
    backgroundColor: '#f8bbd0',
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginRight: theme.spacing(1),
  },
  commentText: {
    flex: 1,
  },
  commentInput: {
    marginTop: theme.spacing(1),
  },
  postButton: {
    marginTop: theme.spacing(1),
  },

  commentListTitle: {
    backgroundColor: '#e3e3e3',
    borderRadius: 50,
    paddinghorizontal: 10,
    paddingVertical: 5,
  },
}));

//日報コメントcontext一覧
interface DailyReportsCommentContextProps {
  comments: DailyReportComment[];
  setComments: (e: DailyReportComment[]) => void;
}

export const DailyReportsCommentContext = React.createContext<DailyReportsCommentContextProps>(
  {} as DailyReportsCommentContextProps
);

interface DailyReportCommentListProps {
  dailyReport: DailyReport;
  dailyReportComments: DailyReportComment[];
  showComment: boolean;
  onSendComment: (comment: DailyReportComment) => void;
  onCommentRead: (id: number) => void;
  onCommentDelete: (id: number) => void;
  componetCommentListBottom?: React.ReactNode;
}

/**
 * 日報コメント一覧
 * @param props
 * @returns
 */
const DailyReportCommentList = (props: DailyReportCommentListProps) => {
  // const { showComments } = React.useContext(DailyReportCommentOpenContext);
  const { dailyReportComments, dailyReport, onCommentRead, onSendComment } = props;
  const [comments, setComments] = useState<DailyReportComment[]>(dailyReportComments);
  const [isOpenComment, setIsOpenComment] = useState(props.showComment);
  const [comment, setComment] = useState<string>('');
  const classes = useStyles();

  // コメント表示/非表示を切り替える関数
  const toggleComments = () => {
    setIsOpenComment(prev => !prev);
  };

  const onSave = async (stamp?: Stamp) => {
    if ((!comment || comment === '') && !stamp) return;
    try {
      const result = await new DailyReportCommentModel({
        id: 0,
        created_at: null,
        updated_at: null,
        deleted_at: null,
        user_id: 0,
        fk_daily_reports_id: dailyReport.id || 0,
        comment: comment,
        user: null,
        stamp_id: stamp?.id,
      }).save();

      // 保存が成功した場合、コメントリストに追加
      if (result && result.success) {
        NotificationToast().success('登録しました。');
        onSendComment(result.data);
        // setComments([...comments, result.data]);
        setComment(''); // コメント入力フィールドをクリア
      } else {
        NotificationToast().error('登録に失敗しました。');
        console.error('Failed to save comment.');
      }
    } catch (error) {
      NotificationToast().error('登録に失敗しました。');
      console.error('Failed to save comment.');
    }
  };

  const commentCount = `${comments.length}件`;

  React.useEffect(() => {
    setIsOpenComment(props.showComment);
  }, [props.showComment]);

  React.useEffect(() => {
    setComments(dailyReportComments);
  }, [dailyReportComments]);

  return (
    <Paper className={classes.root}>
      {/* <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            backgroundColor: isOpenComment ? '#adc7fd' : '#e3e3e3',
            borderRadius: '50px',
            padding: '2px 5px',
            marginBottom: '2px',
          }}
          onClick={toggleComments}
        >
          <Typography variant="body2" gutterBottom>{`日報コメント ${commentCount} ${
            isOpenComment ? '(開)' : '(閉)'
          }`}</Typography>
        </div>
      </div> */}
      {/* コメント表示 */}
      {isOpenComment && (
        <DailyReportsCommentContext.Provider value={{ comments, setComments }}>
          <div className={classes.commentSection}>
            <div className={classes.commentListTitle}>
              {comments.map(comment => (
                <DailyReportCommentItem
                  key={comment.id}
                  dailyReportComment={comment}
                  onCommentDelete={props.onCommentDelete}
                  onReadStatusChange={() => onCommentRead(comment.id ?? 0)}
                />
              ))}
            </div>
          </div>
        </DailyReportsCommentContext.Provider>
      )}
      {props.componetCommentListBottom && props.componetCommentListBottom}
      <CommentInput
        comment={comment}
        onChange={setComment}
        onSend={onSave}
        max={300}
        onSendStamp={onSave}
      />
    </Paper>
  );
};

export default DailyReportCommentList;
